<div class="w-full">
    <form action="" class="flex flex-col md:flex-row items-center justify-between w-full gap-0 md:gap-2 px-4 md:px-8 mt-4">
        <div class="flex flex-col md:flex-row items-center gap-0 md:gap-2 w-full md:w-8/12">
            <mat-form-field class="fuse-mat-dense flex-1 w-full md:w-auto">
                <mat-label>Departamento</mat-label>
                <input type="text"
                        matInput
                        name="departamento"
                        id="departamento"
                        [matAutocomplete]="auto"
                        (input)="onDepartamentoInput($event.target.value)" 
                        />
            
                <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn" (optionSelected)="getMunicipios($event.option.value)">
                    <mat-option *ngFor="let d of departamentos$ | async" [value]="d">
                    {{d.descripcion }}
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>

            <mat-form-field class="fuse-mat-dense flex-1 w-full md:w-auto">
                <mat-label>Municipio</mat-label>
                <input type="text" #municipioInput
                        matInput
                        name="municipio"
                        id="municipio"
                        [matAutocomplete]="autoMunicipio"
                        (input)="onMunicipioInput($event.target.value)" />

                <mat-autocomplete (optionSelected)="municipioSelected($event.option.value)"
                    #autoMunicipio="matAutocomplete" 
                    [displayWith]="displayFn">
                    <mat-option *ngFor="let m of municipios$ | async" [value]="m">
                    {{ m.descripcion }}
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>

            <mat-form-field class="fuse-mat-dense flex-1 w-full md:w-auto">
                <mat-label>Sección</mat-label>
                <mat-select [(ngModel)]="ColeccionistaFilters.seccion" name="seccion" id="seccion">
                    <mat-option [value]="todas">Todas</mat-option>
                    <mat-option *ngFor="let s of secciones" [value]="s.tipologiaId">
                        {{ s.descripcion }}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field class="fuse-mat-dense flex-1 w-full md:w-auto">
                <mat-label>Nombre / Código</mat-label>
                <input matInput [(ngModel)]="ColeccionistaFilters.buscar" placeholder="Buscar código o nombre" name="nombre" id="nombre" />
            </mat-form-field>

        </div>

        <button (click)="filtrar()" class="flex-1" mat-flat-button [color]="'primary'" class="rounded-full w-full md:w-auto">
            Filtrar
        </button>

    </form>
    
</div>
